import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useEntitySubscription } from '@/hooks/useEntitySubscription';
import { ROUTES } from '@/routes/Routes';
import { captureSentry } from '@/utils/helpers/sentryHelper';

type Args = {
  meetingID: string | null | undefined;
};

export default function useNavigateHomeOnMeetingDeletion({ meetingID }: Args) {
  const navigate = useNavigate();

  const onMeetingDeletion = useCallback(() => {
    navigate(ROUTES.HOME);
  }, [navigate]);

  useEntitySubscription('Meeting', {
    onDelete: {
      variables: {},
      skip: !meetingID,
      onData: ({ data }) => {
        const obj = data.data?.onDeleteMeeting;
        if (!obj) {
          captureSentry({
            title: 'useNavigateHomeOnMeetingDeletion | onData | onDelete | obj is undefined',
            detail: {},
          });
          return;
        }
        if (obj.id !== meetingID) return;
        onMeetingDeletion();
      },
    },
  });
}
